
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 26 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M25.006 6.24l-1.979-1.98c-5.684-5.68-14.929-5.682-20.608 0L.439 6.24a1.5 1.5 0 102.122 2.12L4.54 6.383a11.49 11.49 0 015.38-3.028 3.528 3.528 0 00-.755 2.169 3.558 3.558 0 007.116 0c0-.821-.289-1.567-.756-2.17a11.484 11.484 0 015.381 3.029l1.979 1.979a1.5 1.5 0 102.121-2.121z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h25.445v9.081H0z"}})])])])
          )
        }
      }
    